"use strict"; // PRODUCT - FORM - SHAPE - PROCESS (operation) - CutShape

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OperationsValue = exports.CutShape = exports.ProductShape = exports.Form = exports.Product = void 0;
var Product;

(function (Product) {
  Product["ALLOY"] = "ALLOY";
  Product["ALUMINUM"] = "ALUMINUM";
  Product["BRASS_COPPER_BRONZE"] = "BRASS_COPPER_BRONZE";
  Product["CARBON"] = "CARBON";
  Product["FITTINGS"] = "FITTINGS";
  Product["NICKEL"] = "NICKEL";
  Product["PLASTICS"] = "PLASTICS";
  Product["RED_METALS"] = "RED_METALS";
  Product["STEEL"] = "STEEL";
  Product["STAINLESS"] = "STAINLESS_STEEL";
  Product["TOOL_STEEL"] = "TOOL_STEEL";
  Product["VALVES_FITTINGS"] = "VALVES_FITTINGS";
})(Product || (exports.Product = Product = {})); // NOTE: LEAVE COMMENTED OUT ITEMS (RELATED TO VALVE FITTINGS )


var Form;

(function (Form) {
  Form["BAR"] = "BAR"; // BUTT_WELD = "BUTT_WELD",

  Form["EXPANDED"] = "EXPANDED"; // FASTENERS = "FASTENERS",
  // FLANGE = "FLANGE",

  Form["FLOORING"] = "FLOORING";
  Form["SHEET"] = "SHEET";
  Form["PLATE"] = "PLATE"; // PRESSURE_FITTING = "PRESSURE_FITTING",

  Form["PIPE"] = "PIPE";
  Form["STRUCTURAL"] = "STRUCTURAL";
  Form["TREAD_PLATE"] = "TREAD_PLATE";
  Form["TUBE"] = "TUBE";
  Form["COIL"] = "COIL"; // NIPPLE = "NIPPLE",
  // VALVE = "VALVE"
})(Form || (exports.Form = Form = {})); //NOTE: LEAVE COMMENTED OUT ITEMS (RELATED TO VALVE FITTINGS )


var ProductShape;

(function (ProductShape) {
  ProductShape["ANGLE"] = "Product-ANGLE";
  ProductShape["BALL"] = "Product-BALL";
  ProductShape["BEAM"] = "Product-BEAM";
  ProductShape["BAR_GRATING"] = "Product-BAR_GRATING"; // BUSHING = "BUSHING",

  ProductShape["CHANNEL"] = "Product-CHANNEL"; // COUPLING = "COUPLING",

  ProductShape["DIAMOND"] = "Product-DIAMOND"; // ELBOW = "ELBOW",

  ProductShape["FLAT"] = "Product-FLAT";
  ProductShape["FLATTENED"] = "Product-FLATTENED";
  ProductShape["FLAT_WASHER"] = "Product-FLAT_WASHER";
  ProductShape["GATE"] = "Product-GATE";
  ProductShape["STANDARD"] = "Product-STANDARD";
  ProductShape["HEXAGON"] = "Product-HEXAGON";
  ProductShape["HEX_NUTS"] = "Product-HEX_NUTS";
  ProductShape["HEX_SCREW"] = "Product-HEX_SCREW"; // INSERT = "INSERT ",

  ProductShape["LOCK_WASHER"] = "Product-LOCK_WASHER";
  ProductShape["MEDIUM_PATTERN"] = "Product-MEDIUM_PATTERN";
  ProductShape["OPEN_GRIP"] = "Product-OPEN_GRIP";
  ProductShape["PLUG"] = "Product-PLUG";
  ProductShape["REINFORCING"] = "Product-REINFORCING";
  ProductShape["RECTANGLE"] = "Product-RECTANGLE";
  ProductShape["ROUND"] = "Product-ROUND";
  ProductShape["SOCKET"] = "Product-SOCKET"; // STUB_END = "STUB_END",

  ProductShape["STUDS"] = "Product-STUDS";
  ProductShape["SQUARE"] = "Product-SQUARE";
  ProductShape["TEE"] = "Product-TEE";
  ProductShape["THREADED_ROD"] = "Product-THREADED_ROD";
  ProductShape["U_BOLT"] = "Product-U_BOLT";
})(ProductShape || (exports.ProductShape = ProductShape = {}));

var CutShape;

(function (CutShape) {
  CutShape["CIRCLE"] = "CIRCLE";
  CutShape["RECTANGLE"] = "RECTANGLE";
  CutShape["RING"] = "RING";
  CutShape["SQUARE"] = "SQUARE";
})(CutShape || (exports.CutShape = CutShape = {}));

var OperationsValue;

(function (OperationsValue) {
  OperationsValue["ABM"] = "AluminumPlateSaw";
  OperationsValue["APS"] = "AluminumPrecisionPlateSaw";
  OperationsValue["BSC"] = "BandsawCut";
  OperationsValue["CTL"] = "CutToLength";
  OperationsValue["LZR"] = "Laser";
  OperationsValue["BRN"] = "OxyFuelBurning";
  OperationsValue["PFC"] = "Plasma";
  OperationsValue["PBS"] = "PrecisionBandsaw";
  OperationsValue["SHR"] = "Shear";
  OperationsValue["STL"] = "ShearToLength";
  OperationsValue["STW"] = "ShearToWidth";
  OperationsValue["MVP"] = "MVP";
})(OperationsValue || (exports.OperationsValue = OperationsValue = {}));
/*


// NOTE : NOT USED CURRENTLY -- However leave until next sprint! May be used for further refinement


// NOT USED CURRENTLY
// export enum operationsDisplay {
// 	"ABM" = "Aluminum Plate Saw",
// 	"APS" = "Aluminum Precision Plate Saw",
// 	"BSC" = "Band Saw Cut",
// 	"CTL" = "Cut To Length",
// 	"LZR" = "Laser Cut",
// 	"BRN" = "Oxy Fuel Burning",
// 	"PFC" = "Plasma Flame Cut",
// 	"PBS" = "Precision Band Saw",
// 	"SHR" = "Shear",
// 	"STL" = "Shear to Length",
// 	"STW" = "Shear to Width",
// 	"MVP" = "MVP"
// }


// export enum finish {
// 	Vinyl1 = "Blk/wht Vinyl 1 Side",
// 	Vinyl2 = "Blk/wht Vinyl 2 Side",
// 	Chip = "Chip",
// 	Debur = "Debur",
// 	Laser1 = "Laser Vinyl 1 Side",
// 	Laser2 = "Laser Vinyl 2 Side",
// 	Paper = "Paper Interleave",
// 	MarkGrind = "Start/Stop Mark Grind",
// 	TopGrind = "Top Side Grind"
// }

export const RyersonFormCode: { [key: string]: string } = {
    Plate: "PLATE",
    Bar: "BAR",
    CoiledTube: "COILED TUBE",
    CoiledThread: "COILED TREAD",
    Tube: "TUBE",
    Coil: "COIL",
    Sheet: "SHEET",
    Treadplate: "TREAD PLATE",
    Structural: "STRUCTURAL",
    Pipe: "PIPE"
};

export enum EUnitOfMeasure {
    LB = "LB",
    CWT = "CWT",
    EA = "EA",
    PC = "PC",
    FT = "FT",
    FT2 = "FT2",
    IN = "IN",
    SQIN = "SQIN"
}

export const PartShapeMap: { [key: string]: string } = {
    Circle: "Circle",
    Rectangle: "Rectangle",
    Ring: "Ring",
    Square: "Square"
};


export const finishTypes: { [key: string]: string } = {
    Vinyl1: "Blk/wht Vinyl 1 Side",
    Vinyl2: "Blk/wht Vinyl 2 Side",
    Chip: "Chip",
    Debur: "Debur",
    Laser1: "Laser Vinyl 1 Side",
    Laser2: "Laser Vinyl 2 Side",
    Paper: "Paper Interleave",
    MarkGrind: "Start/Stop Mark Grind",
    TopGrind: "Top Side Grind"
};
*/